import { css } from 'styled-components';
import { colors } from '../../atoms/colors/colors';
export const hyperlinkDarkTheme = {
    base: css `
    &,
    &:visited {
      color: ${colors.warmgrey300};
    }

    &:hover {
      color: ${colors.sunset100};
    }
  `,
    bold: css `
    &,
    &:visited {
      color: ${colors.warmgrey300};
      font-weight: 500;
      text-decoration-color: ${colors.sunset100};
      text-decoration-thickness: 2px;
    }

    &:hover {
      color: ${colors.ultramarine900};
      background-color: ${colors.sunset100};
    }
  `,
    color: css `
    color: ${colors.ultramarine300};
    text-decoration: none;
    
    &:visited {
      color: ${colors.warmgrey300};
    }
    
    &:hover {
    color: ${colors.ultramarine100};
    text-decoration: underline;
  `,
};
//# sourceMappingURL=dark-theme.js.map